import { getOwaLazyErrorConfig } from 'mini-error-handler/lib/utils/getOwaLazyErrorConfig';
import { LazyModule } from 'owa-bundling';
import { withSilentErrorHandler } from 'mini-error-handler/lib/components/withSilentErrorHandler';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "USQWarningCard" */ './lazyIndex')
);

export const LazyUSQWarningCard = withSilentErrorHandler(
    null,
    getOwaLazyErrorConfig(lazyModule, m => m.USQWarningCard)
);
